<div *ngIf="!loader; else spinner">
  <ng-content select="[content]"></ng-content>
</div>
<ng-template #spinner>
  <div class="spinner-wrapper">
    <mat-progress-spinner [diameter]="diameter" mode="indeterminate"></mat-progress-spinner>
  </div>
</ng-template>
